// extracted by mini-css-extract-plugin
module.exports = {"GameInterface":"GameInterface_GameInterface__3VdKe","flipped":"GameInterface_flipped__1x7qN","specialActions":"GameInterface_specialActions__3Skl5"};